<template>
	<div class="accordionTabs">
		<div @click="acessarSubmenu('MyDebits', 5)" class="accordionRow bg-left-bottom" :style="style">
			<div class="avatarAccordion">
				<i class="fas fa-dollar-sign" />
			</div>
			<div class="infoAccordion">
				<h4>Minhas Dívidas</h4>
				<h5>Você possui dívidas ?</h5>
			</div>
		</div>
		<div @click="acessarSubmenu('MyAgreements', 3)" class="accordionRow bg-center-center" :style="style">
			<div class="avatarAccordion">
				<i class="fas fa-handshake" />
			</div>
			<div class="infoAccordion">
				<h4>Meus Acordos</h4>
				<h5>Consulte seus acordos e pagamentos</h5>
			</div>
		</div>
		<div v-if="parceiroConfig.sessoes.omniChannel && parceiroConfig.sessoes.omniChannel.campos" @click="acessarSubmenu('TalkToUs')" class="accordionRow bg-right-top" :style="style">
			<div class="avatarAccordion">
				<i class="fas fa-comment-dots" />
			</div>
			<div class="infoAccordion">
				<h4>Fale conosco</h4>
				<h5>Entre em contato com a gente escolhendo um dos canais.</h5>
			</div>
		</div>
		<div @click="acessarSubmenu('FAQ', 6)" class="accordionRow bg-right-top" :style="style">
			<div class="avatarAccordion">
				<i class="fas fa-question-circle" />
			</div>
			<div class="infoAccordion">
				<h4>Dúvidas</h4>
				<h5>Possui alguma dúvida ?</h5>
			</div>
		</div>
		<div @click="parceiro ? $router.push('/') : $router.push({ name: 'LandPage' })" class="accordionRow bg-left-top" :style="style">
			<div class="avatarAccordion">
				<i class="fas fa-times" />
			</div>
			<div class="infoAccordion">
				<h4>Sair</h4>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
	name: "AccordionTabs",
	data() {
		return {
			style: {
				"--color": null,
				"--hovercolor": null
			}
		};
	},
	mounted() {
		if (this.cpfCnpj == "") {
			this.$router.push({ name: "LandPageParceiro" });
		}
		this.style = {
			"--color": this.parceiro ? this.parceiroConfig.estilo.corSecundaria : "#003e6c",
			"--hovercolor": this.parceiro ? this.parceiroConfig.estilo.corSecundaria : "#003e6c"
		};
		this.action_salvar_etapa({
			cpfCnpj: this.cpfCnpj,
			esn_fk_ets_codigo: 37,
			emp_codigo: this.parceiroConfig.emp_codigo
		}).then((response) => {});
		window.fbq("trackCustom", "Menu Principal");
	},
	watch: {
		parceiroConfig() {
			this.style = {
				"--color": this.parceiro ? this.parceiroConfig.estilo.corSecundaria : "#003e6c",
				"--hovercolor": this.parceiro ? this.parceiroConfig.estilo.corSecundaria : "#003e6c"
			};
		}
	},
	computed: {
		...mapState({
			parceiro: (state) => state.parceiro,
			parceiroConfig: (state) => state.parceiroConfig,
			cpfCnpj: (state) => state.cpfCnpj
		})
	},
	methods: {
		...mapMutations(["CHANGE_MESSAGE_MODAL"]),
		...mapActions(["action_salvar_etapa"]),
		acessarSubmenu(submenu, ets_codigo = "") {
			this.$router.push({ name: submenu });
			this.action_salvar_etapa({
				cpfCnpj: this.cpfCnpj,
				esn_fk_ets_codigo: ets_codigo,
				emp_codigo: this.parceiroConfig.emp_codigo
			}).then((response) => {});
		}
	}
};
</script>

<style scoped lang="scss">
.accordionTabs {
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	background: #f5f7f9;
	justify-content: space-evenly;
	align-items: center;
	@media only screen and (max-width: 990px) {
		height: 85vh;
		min-height: auto;
	}
}

.accordionRow {
	box-sizing: border-box;
	width: 100%;
	background: var(--whiteColor);
	display: flex;
	flex: 1;
	margin: 0.5px 0;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	padding-left: 3vw;
	transition: 0.3s;
	box-shadow: 0 1px 2px rgba(3, 27, 78, 0.16);
	@media only screen and (max-width: 990px) {
		padding-left: 45px;
	}
}

.accordionRow:hover {
	background: var(--hovercolor);
	cursor: pointer;
}

.accordionRow:hover i,
.accordionRow:hover h4,
.accordionRow:hover h5 {
	color: var(--whiteColor);
}

.avatarAccordion {
	width: 100px;
	height: 100px;
	border-radius: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	@media only screen and (max-width: 990px) {
		width: 50px;
		height: 50px;
		border-radius: 100%;
	}
}

.avatarAccordion i {
	font-size: 48px;
	color: var(--color);
}

.infoAccordion {
	@media only screen and (max-width: 990px) {
		padding-left: 20px;
	}
}

.infoAccordion h4 {
	color: var(--color);
	font-size: 32px;
	font-family: Montserrat-Bold;
	@media only screen and (max-width: 990px) {
		font-size: 24px;
	}
}

.infoAccordion h5 {
	color: #969191;
	font-size: 16px;
	font-family: Montserrat-Regular;
	@media only screen and (max-width: 990px) {
		font-size: 14px;
	}
}

.bg-left-bottom {
	background-position: left bottom;
}

.bg-center-center {
	background-position: center center;
}

.bg-right-top {
	background-position: right top;
}

.bg-left-top {
	background-position: left top;
}
</style>
